<template>
  <div>
    <b-row>
      <b-col>
        <h3><strong>
          Information
        </strong></h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Company</h5>
        <p>{{ companyName }}</p>
      </b-col>
      <b-col>
        <h5>Category</h5>
        <p>(H)ealth</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Languages</h5>
        <p>{{ languages }}</p>
      </b-col>
      <b-col>
        <h5>Age Rating</h5>
        <p> 5+ </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>In-App Purchases</h5>
        <p>None</p>
      </b-col>
      <b-col>
        <h5>Subscriptions</h5>
        <p>None</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Version</h5>
        <p>v{{ versionNumber }}</p>
      </b-col>
      <b-col>
        <h5>Copyright</h5>
        <p>{{companyName}} {{ copyrightYear }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <hr/>
        <b-link>
          <b-icon icon="shield-lock-fill"/>
          Privacy Policy
        </b-link>
      </b-col>
      <b-col>
        <hr />
        <b-link>
          <b-icon icon="book-fill"/>
          Terms
        </b-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "MyApp_DetailView_DetailInfo",
  components: {},
  props: {
    tool: {
      type: Object,
      default: () => {return {}}
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  data() {
    return {
      companyName: this.tool && this.tool.company ? this.tool.company.name: '',
      copyrightYear: this.tool && this.tool.company ? this.tool.copyrightYear: '',
      companyEmail: this.tool && this.tool.company ? this.tool.company.email: '',
      price: this.tool ? this.tool.price: null,
      rating: this.tool ? this.tool.rating: null,
      ratingLevel: this.tool ? this.tool.ratingLevel: '',
      versionNumber: this.version && this.version.number ? this.tool.version.number : '0.5',
      //Add- TBD
      categories: '(H)ealth',
      languages : 'English, Spanish',
      connections : 'Alexa, Alexa Show',
      standalones : 'Web, iOS, Android'
    }
  }
}
</script>
<style lang="scss" scoped></style>
